import * as React from 'react';

import {colors} from 'shells/colors/colors';
import {buildGradientString} from 'shells/cue-card/helpers';
import {OnboardingModal} from 'shells/onboarding-modal/onboarding-modal';

import {HelpLeadRecapsBody} from './help-lead-recaps-body';
import {HelpLeadRecapsGraphic} from './help-lead-recaps-graphic';

export type LeadRecapsHelpPage = 'page-1' | 'page-2' | 'page-3';

const AI_PURPLE_GRADIENT = buildGradientString({
    colors: ['aiPurplePink', 'aiPurpleLt', 'aiPurplePrimary'],
    angle: 135,
});

const onboardingPages = [
    {
        id: 'page-1',
        body: <HelpLeadRecapsBody page='page-1' />,
        art: {
            background: colors.aiPurplePrimary,
            backgroundGradient: AI_PURPLE_GRADIENT,
            // @ts-expect-error
            image: (props) => <HelpLeadRecapsGraphic {...props} page='page-1' />,
        },
    },
    {
        id: 'page-2',
        body: <HelpLeadRecapsBody page='page-2' />,
        art: {
            background: colors.aiPurplePrimary,
            backgroundGradient: AI_PURPLE_GRADIENT,
            // @ts-expect-error
            image: (props) => <HelpLeadRecapsGraphic {...props} page='page-2' />,
        },
    },
    {
        id: 'page-3',
        body: <HelpLeadRecapsBody page='page-3' />,
        art: {
            background: colors.aiPurplePrimary,
            backgroundGradient: AI_PURPLE_GRADIENT,
            // @ts-expect-error
            image: (props) => <HelpLeadRecapsGraphic {...props} page='page-3' />,
        },
    },
];

type Props = {
    isOpen: boolean;
    onClose: () => void;
};

export function HelpLeadRecaps(props: Props) {
    const {isOpen, onClose} = props;

    return (
        <OnboardingModal
            onFinish={onClose}
            onClose={onClose}
            lastButtonText='Done'
            pages={onboardingPages}
            isOpen={isOpen}
            maxHeight={586}
            firstButtonText='Next'
            nextButtonText='Next'
        />
    );
}
